module.exports = __webpack_public_path__ + "img/tg-2.77af4aa6.png";